import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppState } from '../../../reducers';
import { select, Store } from '@ngrx/store';
import { SaveDataTablesConfigAction } from '../profile.actions';
import { selectAuthUser, selectAuthUserPreferences } from '../../auth/auth.selectors';
import { Observable, Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { Preferences } from '../../../global/interfaces';
import { PreferencesLabels } from '../profile.models';
import { FINANCIAL_MONTH } from '../profile.models';
import { selectCountrySelected } from '../../../shared/layout/main.selectors';
import { Actions, FieldSize } from 'atlas-cdk';
import { ToastService } from '../../../shared/toaster_/toaster_.service';

@Component({
  standalone: false,
  selector: 'dsp-data-tables',
  templateUrl: 'data-tables.component.html',
  styleUrls: ['data-tables.component.scss']
})
export class DataTablesComponent implements OnInit, OnDestroy {
  public preferences: Preferences;
  public prefLabels: { [key: string]: string } = PreferencesLabels;
  public FINANCIAL_MONTH = FINANCIAL_MONTH;
  public preferences$: Observable<string[]>;
  public country = '';
  public sizeMedium = FieldSize.medium;
  public sizeSmall = FieldSize.small;

  private readonly subscription: Subscription = new Subscription();
  public constructor(
    private readonly store: Store<AppState>,
    private readonly _toasterService: ToastService
  ) {
    this.preferences$ = this.selectPreferences();
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribePreferences());
    this.subscription.add(this.subscribeSelectedCountry());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public onSubmit(): void {
    this.store.dispatch(new SaveDataTablesConfigAction(this.preferences));
  }

  public onCancel(): void {
    this.store.pipe(
      select(selectAuthUserPreferences),
      take(1)
    ).subscribe(preferences => {
      this.preferences = { ...preferences } as Preferences;
      //this.store.dispatch(new AddErrorToastAction('Changes have been cancelled'));
      return this._toasterService.launchAlertError("Changes have been cancelled", Actions.error);
    });
  }

  private selectPreferences(): Observable<string[]> {
    return this.store.pipe(
      select(selectAuthUserPreferences),
      map(preferences => {
        const keys = Object.keys(preferences || {});
        // Sort to ensure financialYearStartMonth comes first
        return keys.sort((a, b) => {
          if (a === 'financialYearStartMonth') return -1;
          if (b === 'financialYearStartMonth') return 1;
          return 0;
        });
      })
    );
  }

  private subscribePreferences(): Subscription {
    return this.store.pipe(
      select(selectAuthUserPreferences)
    ).subscribe(preferences => {
      this.preferences = { ...preferences } as Preferences;
    });
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
    });
  }

  public getNumberOptions(): Array<{ label: string; value: number }> {
    return [0, 1, 2, 3, 4, 5].map(num => ({ label: num.toString(), value: num }));
  }
}
